import { Routes } from "@angular/router";
import { AuthGuard } from "@main-services/auth-guard.service";

export const routes: Routes = [
	{
		outlet: "modal",
		path: "demo-modal",
		loadChildren: () =>
			import("@modules/+new/shared/universal-modal/_demo/modal-routed/modal-routed.module").then(
				(m) => m.ModalRoutedModule
			),
		canActivate: [AuthGuard]
	}
];
